/** Token saved by redux-persist under localStorage `admin`. Missing or partial data returns undefined so the caller can use the in-memory session. */
export function readPersistedAccessToken(persistData: unknown): string | undefined {
    if (!persistData || typeof persistData !== 'object') return undefined
    const token = (persistData as { auth?: { session?: { token?: unknown } } }).auth?.session?.token
    return typeof token === 'string' && token ? token : undefined
}
